import React from 'react';
import { renderContent } from 'utilities/content/content-utilities';
import { PriceTerm } from 'types/Product';
import WeeklyBreakdown from './WeeklyBreakdown';
import { DialogSection, DialogText } from '../../styles/DialogStyles';

interface Props {
  longestWeeklyPriceTermWithZeroInterest: PriceTerm;
  productName: string;
}

function InterestFreeContent(props: Props) {
  const { longestWeeklyPriceTermWithZeroInterest, productName } = props;

  return (
    <div data-testid="interest-free-content">
      <DialogSection>
        <DialogText data-testid="longest-interest-free-price-term" size="1" tag="p" type="paragraph">
          With our interest free credit you could get this item from just{' '}
          <strong>{longestWeeklyPriceTermWithZeroInterest.weeklyPaymentAmount}</strong> per week and never pay more than{' '}
          <strong>{longestWeeklyPriceTermWithZeroInterest.totalSellingPrice}</strong>
        </DialogText>

        <WeeklyBreakdown
          productName={productName}
          skuPrice={longestWeeklyPriceTermWithZeroInterest.totalSellingPrice}
          weeklyTermPeriod={longestWeeklyPriceTermWithZeroInterest.termPeriod}
          weeklyTermMessage={`Interest free (${longestWeeklyPriceTermWithZeroInterest.apr}% APR)`}
          weeklyPrice={longestWeeklyPriceTermWithZeroInterest.weeklyPaymentAmount}
        />
      </DialogSection>

      <DialogSection>
        <DialogText size="1" tag="p" type="paragraph">
          <strong>20</strong> weeks <strong>interest free</strong> available on all items
        </DialogText>

        <DialogText size="1" tag="p" type="paragraph">
          <strong>52</strong> weeks <strong>interest free</strong> available on items over <strong>£250</strong>
        </DialogText>

        <DialogText size="1" tag="p" type="paragraph">
          <strong>{renderContent('littlewoods.spreadTheCostFurther.info1.1')}</strong>{' '}
          {renderContent('littlewoods.spreadTheCostFurther.info1.2')}
        </DialogText>

        <DialogText size="1" tag="p" type="paragraph">
          <strong>{renderContent('littlewoods.spreadTheCostFurther.info2')}</strong>
        </DialogText>
      </DialogSection>
    </div>
  );
}

export default InterestFreeContent;
